'use client';

import { useStore } from '@/providers/app-store-provider';
import { IS_US } from '@/utils/constants';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

interface PublicResourceLike {
  jsonvalues?: {
    compliance_subscription_display?: {
      switch?: number | string;
    };
  };
}

const isJsonSwitchEnabled = (publicResourceData: PublicResourceLike) => {
  const config = publicResourceData?.jsonvalues?.compliance_subscription_display || {};
  const switchValue = config.switch;
  return switchValue === 1 || switchValue === '1';
};

const MARKETING_STATUS_ROUTE_WHITELIST = [
  // common
  '/search-result',
  '/goods-list',
  '/goods-detail',
  '/cart',
  '/coupons',
  '/account/account-security',
  '/account/communication-preferences',
  '/account/my-address-book',
  '/payment',

  // pc
  // m
];

/** 个人中心路由：不依赖 jsonvalues 开关，仍需拉取 marketingStatus */
const ACCOUNT_ROUTE_PREFIXES = [
  '/account/account-security',
  '/account/communication-preferences',
  '/account/my-address-book',
];

export const useComplianceMarketingStatusInit = () => {
  const pathname = usePathname();
  const token = useStore((state) => state.token);
  const clientTokenReady = useStore((state) => state.clientTokenReady);
  const publicResourceData = useStore((state) => state.publicResourceData as PublicResourceLike);
  const setComplianceMarketingStatus = useStore((state) => state.setComplianceMarketingStatus);
  const getMarketingStatus = useStore((state) => state.getMarketingStatus);

  const isRouteEnabled = MARKETING_STATUS_ROUTE_WHITELIST.some((path) => pathname?.includes(path));
  const isAccountRoute = ACCOUNT_ROUTE_PREFIXES.some((path) => pathname?.includes(path));
  const shouldFetchMarketingStatus =
    IS_US &&
    !!token &&
    isRouteEnabled &&
    (isAccountRoute || isJsonSwitchEnabled(publicResourceData));

  useEffect(() => {
    if (!clientTokenReady) return;

    if (!shouldFetchMarketingStatus) {
      setComplianceMarketingStatus(undefined);
      return;
    }

    setComplianceMarketingStatus(undefined);
    getMarketingStatus();
  }, [
    clientTokenReady,
    getMarketingStatus,
    isRouteEnabled,
    pathname,
    shouldFetchMarketingStatus,
    setComplianceMarketingStatus,
    token,
  ]);
};
